// @flow

import identity from 'lodash/identity';
import { currentDevice } from 'src/modules/chalice-user-agent/device-detect';
import cookie from 'cookie';
import isBoolean from 'lodash/isBoolean';

const AndroidStoreLink: AppInstallBanner$StoreLinkFn = () =>
  'https://play.google.com/store/apps/details?id=au.com.seek&hl=en';

const iTunesStoreLink: AppInstallBanner$StoreLinkFn = ({
  locale,
  path,
  campaignSuffix = ''
}) => {
  const iTunesUrl = 'https://itunes.apple.com';
  const appId = '520400855';
  const mediaType = '8'; // Mobile Software Applications
  const campaignToken = `${locale}seek-respappbanner-${path}${
    campaignSuffix ? `-${campaignSuffix}` : ''
  }`;
  const ptParam = '992740';

  return (
    `${iTunesUrl}/` +
    `${locale.toLocaleLowerCase()}/` +
    'src/seek-jobs/' +
    `id${appId}?` +
    `pt=${ptParam}&` +
    `mt=${mediaType}&` +
    `ct=${campaignToken}`
  );
};

export const appStoreLink = (
  device: MobileDevices
): AppInstallBanner$StoreLinkFn =>
  ({
    iPhone: iTunesStoreLink,
    Android: AndroidStoreLink,
    Other: () => '/' // Send all other devices back to the homepage will never be called on the current app banner
  }[device]);

const currentDate = new Date(Date.now());

const BANNER_KEY = 'sk-banner-item'; // key to lookup in localStore

const isCurrentPath = pathname => (path: TargetPath) =>
  new RegExp(path.regex).test(pathname);

export const isATargetDevice = (devices: Array<MobileDevices>): boolean =>
  devices.map(device => device === currentDevice()).some(identity);

export const dismissFor = (days: number): void => {
  document.cookie = cookie.serialize(BANNER_KEY, 'true', {
    expires: new Date(currentDate.setDate(currentDate.getDate() + days))
  });
};

export const isCookieSet = (): boolean =>
  cookie.parse(document.cookie)[BANNER_KEY] === 'true';

export const currentPlatform = (device: MobileDevices) =>
  device === 'iPhone' ? 'iOS' : 'Android';

export const getCurrentRating = (device: MobileDevices) =>
  ({
    Android: {
      value: 4.3,
      count: '13,156',
      reviewQuote:
        '…this is most definitely helping me get back into the work force as quickly as possible.'
    },
    iPhone: {
      value: 3.8,
      count: '3604',
      reviewQuote:
        'I have been using a few search apps of late and Seek wins, hands down. There is actually no comparison.'
    },
    Other: {
      value: 0,
      count: '0',
      reviewQuote: ''
    } // Will never actually be used, but required for the type definition
  }[device]);

export const filterCurrentPath = (showOnPaths: Array<TargetPath>) => (
  pathname: string
): Array<TargetPath> => showOnPaths.filter(isCurrentPath(pathname));

export const shouldShowBanner = ({
  forceActive,
  showOnPaths = [],
  pathname,
  targetDevices = []
}: AppInstallBanner$Props): boolean => {
  if (ENV.SERVER) {
    return false;
  }

  if (isCookieSet()) {
    return false;
  }

  if (!isATargetDevice(targetDevices)) {
    return false;
  }

  if (isBoolean(forceActive)) {
    return Boolean(forceActive); // Boolean() here is just for flow
  }

  return Boolean(filterCurrentPath(showOnPaths)(pathname).length);
};
